import parseDialogue from "../../util/parseDialogue";

export const KimoniRevisit = parseDialogue(`
kimoni:revisit:100-200

#100 I see you've returned. Be assured that you will find no better than Kimoni's shop anywhere on the net. The question is, do you have the credits to make this worth our while?
>200 Show me what you've got.
>0 No thanks.
`);
